import { Database, Bot, TrendingUp, Wallet, Network, Cpu, ArrowUpRight } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

const iconMap = { Database, Bot, TrendingUp, Wallet, Network, Cpu };

export default function Services() {
  const { t } = useLang();
  return (
    <section id="services" className="py-24 lg:py-32 relative" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 mb-16">
          <div className="lg:col-span-5">
            <p className="bbm-eyebrow mb-4">— {t.services.eyebrow}</p>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-[#0B132B] leading-tight tracking-tight">
              {t.services.title}
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 flex items-end">
            <p className="text-[#4B5563] text-lg leading-relaxed">{t.services.sub}</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#E5E7EB] border border-[#E5E7EB] rounded-lg overflow-hidden">
          {t.services.items.map((s, i) => {
            const Icon = iconMap[s.icon] || Database;
            return (
              <div
                key={i}
                className="bg-white p-8 group hover:bg-[#F9FAFB] transition-colors relative"
                data-testid={`service-card-${i}`}
              >
                <div className="flex items-start justify-between mb-6">
                  <div className="w-12 h-12 rounded-lg bg-[#0B132B] flex items-center justify-center group-hover:bg-[#0047FF] transition-colors">
                    <Icon className="w-5 h-5 text-white" strokeWidth={1.75} />
                  </div>
                  <span className="font-mono text-[10px] uppercase tracking-widest text-[#4B5563]">
                    0{i + 1}
                  </span>
                </div>
                <h3 className="font-display text-xl text-[#0B132B] mb-3">{s.title}</h3>
                <p className="text-[#4B5563] text-sm leading-relaxed">{s.desc}</p>
                <ArrowUpRight className="w-4 h-4 absolute bottom-6 end-6 text-[#0B132B] opacity-0 group-hover:opacity-100 transition-opacity bbm-flip" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
